import React from "react";
import createSvgIcon from "./utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <path d="M19.5 5a2 2 0 012 2v14a2 2 0 01-2 2h-11a2 2 0 01-2-2V7a2 2 0 012-2h11zm0 2h-11v14h11V7zm-7.362 3.735l.094.083L14 12.585l1.769-1.767a1 1 0 011.497 1.32l-.083.094L15.414 14l1.768 1.769a1 1 0 01-1.32 1.497l-.094-.083-1.769-1.768-1.767 1.768a1 1 0 01-1.497-1.32l.083-.094 1.767-1.769-1.767-1.767a1 1 0 011.32-1.497zM15.5 1c.55 0 1 .45 1 1s-.45 1-1 1h-10c-.55 0-1 .45-1 1v12c0 .55-.45 1-1 1s-1-.45-1-1V3c0-1.1.9-2 2-2h11z" />
  </React.Fragment>,
  "Deduplicated"
);
